/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Ateliere_Connect_Status_Video_DetailsInputs */

const en_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Getting details for video file: ${i?.id}...`)
};

const fr_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Récupération des détails du fichier vidéo : ${i?.id}...`)
};

const de_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Details zur Videodatei werden abgerufen: ${i?.id}...`)
};

const it_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ottenimento dei dettagli per il file video: ${i?.id}...`)
};

const ru_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Получение информации о видеофайле: ${i?.id}...`)
};

const es_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obteniendo detalles del archivo de vídeo: ${i?.id}...`)
};

const zh_cn2_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在获取视频文件${i?.id}的详细信息...`)
};

const ja_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオファイルの詳細を取得しています: ${i?.id}...`)
};

const hi_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल ${i?.id} के लिए विवरण प्राप्त किए जा रहे हैं...`)
};

const pt_pt2_ateliere_connect_status_video_details = /** @type {(inputs: Ateliere_Connect_Status_Video_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtendo detalhes do arquivo de vídeo: ${i?.id}...`)
};

/**
* | output |
* | --- |
* | "Getting details for video file: {id}..." |
*
* @param {Ateliere_Connect_Status_Video_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_video_details = /** @type {((inputs: Ateliere_Connect_Status_Video_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Video_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_video_details(inputs)
	if (locale === "de") return de_ateliere_connect_status_video_details(inputs)
	if (locale === "it") return it_ateliere_connect_status_video_details(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_video_details(inputs)
	if (locale === "es") return es_ateliere_connect_status_video_details(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_video_details(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_video_details(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_video_details(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_video_details(inputs)
	return en_ateliere_connect_status_video_details(inputs)
});